import {client} from '../util/createRestApiClient';

const base = "msal-setting";
export default () => ({
    getMSALSettings: () => client.request({
        method: 'GET',
        url: base
    }),
    updateMSALSettings: (params) => client.request({
        method: 'PUT',
        url: base,
        data: {
          clientID: params.clientID,
          tenantID: params.tenantID,
          redirectUri: params.redirectUri,
          groups: params.groups
        }
      }),

}
);
